import { api } from "./client";

export interface MetricProposal {
  id: string;
  key: string;
  label: string;
  description: string | null;
  category: string;
  sourceModel: string;
  sourceExplore: string;
  measureField: string;
  defaultOperator: string;
  defaultThreshold: string;
  defaultSeverity: string;
  unitOfMeasure: string | null;
  calculationLogic: string | null;
  businessDefinition: string | null;
  status: string;
  proposedByAgentId: string | null;
  proposedAt: string;
  query: {
    model: string;
    explore: string;
    fields: string[];
    filters?: Record<string, string>;
    sorts?: string[];
    limit?: number;
  };
}

export interface ProposalsResponse {
  total: number;
  byCategory: Record<string, MetricProposal[]>;
}

export interface GenerateResponse {
  requestedCategory: string;
  candidateFieldCount: number;
  proposalsCreated: number;
  proposals: { id: string; key: string; label: string }[];
  skippedAsDuplicate: string[];
  skippedAsInvalid: string[];
  liveExploresLoaded: number;
}

export type MetricValidationIssueType =
  | "explore_not_found"
  | "field_not_found"
  | "looker_error"
  | "no_query";

export interface MetricValidationIssue {
  type: MetricValidationIssueType;
  detail: string;
  field?: string;
}

export interface MetricValidationResult {
  id: string;
  key: string;
  label: string;
  category: string;
  status: string;
  model: string | null;
  explore: string | null;
  valid: boolean;
  issues: MetricValidationIssue[];
}

export interface CatalogValidationReport {
  companyId: string;
  checkedAt: string;
  totalMetrics: number;
  validCount: number;
  invalidCount: number;
  exploresChecked: number;
  brokenExplores: string[];
  results: MetricValidationResult[];
}

export const metricProposalsApi = {
  list: () => api.get<ProposalsResponse>("/admin/metric-proposals"),

  generate: (companyId: string, category: string, maxMetrics?: number) =>
    api.post<GenerateResponse>("/admin/metric-proposals/generate", {
      companyId,
      category,
      maxMetrics,
    }),

  validate: (companyId: string, statuses?: string[]) => {
    const params = new URLSearchParams({ companyId });
    if (statuses?.length) params.set("statuses", statuses.join(","));
    return api.get<CatalogValidationReport>(
      `/admin/metric-proposals/validate?${params.toString()}`,
    );
  },

  approveBatch: (ids: string[], thresholds?: Record<string, string>) =>
    api.post<{ approved: number }>("/admin/metric-proposals/approve-batch", {
      ids,
      thresholds,
    }),

  rejectBatch: (ids: string[]) =>
    api.post<{ rejected: number }>("/admin/metric-proposals/reject-batch", { ids }),
};
